module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "production-quote hideme"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.prodQuote.text))])]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "byline"
  }, [_vm._v(_vm._s(_vm.prodQuote.author))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quote top"
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/icon-quote-top.png",
      "alt": "quote"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quote bottom"
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627709206/fsl/icon-quote-bottom.png",
      "alt": "quote"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-25210919", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25210919","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductionQuote.vue
// module id = 395
// module chunks = 0